import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import React, { useState, useEffect } from 'react';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

import PublicRoute from './components/PublicRoute';
import ProtectedRoute from './components/ProtectedRoute';

import './App.css';
import MainLayout from './layouts/MainLayout';

// Existing Pages
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ProfileUpload from './pages/ProfileUpload';
import MyPhotos from './pages/MyPhotos';
import PhotographerDashboard from './pages/PhotographerDashboard';
import CreateEvent from './pages/CreateEvent';
import EventPhotos from './pages/EventPhotos';
import Analytics from './pages/Analytics';
import AccountSettings from './pages/AccountSettings';
import Pricing from './pages/Pricing';
import EventBrowse from './pages/EventBrowse';
import EditEvent from './pages/EditEvent';
import PaymentHistory from './pages/PaymentHistory';
import NotFound from './pages/NotFound';

// V2 New Pages
import SlideshowViewer from './pages/SlideshowViewer';
import PhotographerProfile from './pages/PhotographerProfile';
// import ContactPage from './pages/ContactPage';
// import DemoPage from './pages/DemoPage';
// import AdminDashboard from './pages/AdminDashboard';
// import GalleryAccess from './pages/GalleryAccess';
// import CheckoutPage from './pages/CheckoutPage';


import PublicEventsPage from './pages/PublicEventsPage';



function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Chargement de PhotoMatch...</p>
      </div>
    );
  }

  return (

    <AuthProvider>
      <CartProvider>
      <BrowserRouter>
      
    
      <div className="App">
        {/*}
        <Navbar user={user} logout={logout} />
        <ToastContainer position="top-right" autoClose={3000} />
        */}
        
        <Routes>
          {/* Public Routes */}
          <Route element={<MainLayout />}>  
          <Route path="/" element={<LandingPage user={user} />} />
          <Route path="/pricing" element={<Pricing user={user} />} />
          {/* <Route path="/demo" element={<DemoPage />} /> */}
          {/* <Route path="/contact" element={<ContactPage />} /> */}
          
          {/* Auth Routes 
          <Route 
            path="/login" 
            element={user ? <Navigate to="/dashboard" /> : <Login login={login} />} 
          />

          
          */}
          
          <Route path="/register"  element={<PublicRoute>  <Register /> </PublicRoute> }           />
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/profile" element={<Navigate to="/account?tab=profile" replace />} />
          <Route path="/settings" element={<Navigate to="/account?tab=security" replace />} />


          {/* User Routes (Protected) 
          <Route 
            path="/dashboard" 
            element={user ? <Dashboard user={user} /> : <Navigate to="/login" />} 
          />

          */}

          <Route 
            path="/profile-upload" element={<ProtectedRoute> <ProfileUpload/> </ProtectedRoute>}
          />
          <Route 
            path="/my-photos" 
            element={<ProtectedRoute> <MyPhotos /> </ProtectedRoute>}
          />
          <Route 
            path="/account" 
            element={<ProtectedRoute> <AccountSettings /> </ProtectedRoute>}
          />
          <Route 
            path="/analytics" 
            element={<ProtectedRoute> <Analytics /> </ProtectedRoute>}
          />
          <Route
            path="/payment-history"
            element={<ProtectedRoute> <PaymentHistory /> </ProtectedRoute>}
          />
          
          {/* Photographer Routes (Protected) */}
          <Route 
            path="/photographer" 
            element={<ProtectedRoute> <PhotographerDashboard/> </ProtectedRoute>}
          />
          <Route 
            path="/create-event" 
            element={<ProtectedRoute> <CreateEvent/> </ProtectedRoute>}
          />
          <Route 
            path="/event/:eventId/photos" 
            element={<ProtectedRoute> <EventPhotos/> </ProtectedRoute>}
          />
          <Route
            path="/event/:eventId/browse"
            element={<ProtectedRoute> <EventBrowse/> </ProtectedRoute>}
          />
          <Route
            path="/event/:eventId/edit"
            element={<ProtectedRoute> <EditEvent/> </ProtectedRoute>}
          />
          
          {/* V2 New Routes */}


          <Route path="/events" element={<PublicEventsPage />} />
          <Route path="/photographer/:photographerId" element={<PhotographerProfile />} />



          <Route 
            path="/gallery/:galleryId/slideshow" 
            element={<SlideshowViewer />} 
          />
          {/* 
          <Route 
            path="/gallery/:galleryId/access" 
            element={user ? <GalleryAccess user={user} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/checkout" 
            element={user ? <CheckoutPage user={user} /> : <Navigate to="/login" />} 
          />
          */}
          
          {/* Admin Routes (Protected) */}
          {/* 
          <Route 
            path="/admin" 
            element={user?.is_admin ? <AdminDashboard user={user} /> : <Navigate to="/dashboard" />} 
          />
          */}
          <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </div>
    

     </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
